// Imports
import { useClearCache } from 'react-clear-cache';
import { KiteProgressIndicator } from '@kite/react-kite';

import AppRouter from 'routes/AppRouter';
import useFetchToken from 'hooks/apiCalls/useFetchToken';

// Styles
import './App.scss';
import { ErrorPage } from 'routes';

const App = () => {
  useClearCache({
    auto: false,
    duration: 300000,
  }); // Automatically clear app cache if new build is found

  // Fetch token on app load
  const { data: tokenObj, isLoading, isError } = useFetchToken();

  if (isLoading) {
    return (
      <div className="loader-container">
        <KiteProgressIndicator id="kp1" title="Loading" />
      </div>
    );
  }

  if (isError || !tokenObj) {
    return <ErrorPage />;
  }

  // Only render routes if token is present
  return (
    <div className="app">
      <AppRouter />
    </div>
  );
};

export default App;
